export default __webpack_public_path__ + "static/media/workoutscf@2x.19e7a28b.png";